import React, { useState } from 'react'
import axios from 'axios'
import "../styles/AdminApplications.css"
import { ApiURL } from '../constants/ApiUrl'
import { useHistory } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from "yup"

import { LinearProgress, TextField, TextareaAutosize, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormHelperText, Button } from '@material-ui/core'
import "../styles/FormPage1.css"
import { myBucket } from '../services/UploadService'

function NoticeForm() {
    const [Type, setType] = useState('')
    const [AppList, setAppList] = useState([])
    const [Notice, setNotice] = useState("")
    const [title, setTitle] = useState("")
    const [subject, setsubject] = useState(false)
    const [notice, setnotice] = useState(false)
    const [subjectError, setSubjectError] = useState("")
    const [noticeError, setnoticeError] = useState("")
    const [status, setstatus] = useState("")
    const [IsOpen1, setIsOpen1] = useState(false)
    const [IsOpen2, setIsOpen2] = useState(false)
    const [sendMeMail, setSendMeMail] = useState(false)

    const [firstImg, setFirstImg] = useState({})
    const [secondImg, setSecondImg] = useState({})
    const [thirdImg, setThirdImg] = useState({})
    const [fourthImg, setFourthImg] = useState({})
    const [fifthImg, setFifthImg] = useState({})

    const [Progress1, setProgress1] = useState(0)
    const [Progress2, setProgress2] = useState(0)
    const [Progress3, setProgress3] = useState(0)
    const [Progress4, setProgress4] = useState(0)
    const [Progress5, setProgress5] = useState(0)
    const history = useHistory();

    const handleCancel = () => {
        history.push('/admin/Noticepage')

    }
    const handleData = () => {
        setIsOpen2(true)
        if (title === "") {
            setSubjectError("Subject is Required!")
            setsubject(true)
            setnotice(false)
        }
        else if (Notice.length < 200) {
            setnoticeError("Notice Must be atleast 200 characters")
            alert("Notice Must be atleast 200 characters")
            if (Notice === "") {
                setnoticeError("Notice is Required")
                alert("Notice Must be atleast 200 characters")
                setnotice(true)
                setsubject(false)

            }

        }
        else {
            setsubject(false)
            setnotice(false)



        }
    }

    const handleSend = async () => {
        setSendMeMail(false)
        setIsOpen1(false)
        if (status == "Active") {
            const result1 = await axios.post(`${ApiURL}/Notice_mail_to_all_users`, {
                userType: Type,
                title: title
            })
            alert(result1.data)
        }
      

    }
    const sendMail = () => {
        setIsOpen1(true)
    }
    const handleSave = async () => {
        var data = {
            title: title,
            Notice: Notice,
            urls: [firstImg, secondImg, thirdImg, fourthImg, fifthImg],
            User_group: Type,
            status: status,
        }

        const result = await axios.post(`${ApiURL}/api/notices_info`, {
            data
        })

        if (status == "Active") {
            setSendMeMail(true)
            alert(result.data)
            setIsOpen2(false)

        }
        else {
            setSendMeMail(false)
            alert(result.data)
            setIsOpen2(false)
            

        }



    }

    const handleNoApp = () => {
        setIsOpen1(false)
        setIsOpen2(true)

    }
    const handleNosave = () => {
        setIsOpen2(false)


    }
    const uploadImg = (e) => {
        const slug = title.replace(/\s+/g, "-")
        let files = e.target.name
        if (files === "firstImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress1(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const first = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setFirstImg({ path: first, key: params.Key })

                    }
                })
        }

        else if (files === "secondImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress2(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const second = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setSecondImg({ path: second, key: params.Key })
                    }
                })
        }
        else if (files === "thirdImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress3(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const third = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setThirdImg({ path: third, key: params.Key })
                    }
                })
        }
        else if (files === "fourthImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress4(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const fourth = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setFourthImg({ path: fourth, key: params.Key })
                    }
                })
        }
        else if (files === "fifthImg") {
            const file = e.target.files;
            let ext = file[0].name.split('.').pop().toLowerCase();
            if (file.length === 0) {
                return;
            }
            if (ext !== "pdf" && ext !== "jpg" && ext !== "jpeg" && ext !== "bmp" && ext !== "png") {
                alert("Only Pdf,jpg,jpeg,bmp,png files allowed");
                return;
            }
            const params = {
                ACL: 'public-read',
                Body: file[0],
                Bucket: process.env.REACT_APP_Bucket,
                Key: `Notices/${slug}/${files}.${ext}`
            }
            myBucket.putObject(params)
                .on('httpUploadProgress', (evt) => {
                    setProgress5(Math.round((evt.loaded / evt.total) * 100))
                })
                .send((err, data) => {
                    if (err) console.log(err)
                    else {
                        const fifth = (`https://${process.env.REACT_APP_Bucket}.s3.ap-south-1.amazonaws.com/Notices/${slug}/${files}.${ext}`);
                        setFifthImg({ path: fifth, key: params.Key })

                    }
                })
        }
    }


    return (

        <div style={{ width: '40%', margin: "auto", position: "relative" }}>
            <div>
                <h2>Add a Notice</h2>
                <div>
                    <select className="newSelect" onChange={(e) => setType(e.target.value)}>
                        <option value='all'>Notice For</option>
                        <option value='All'>All Members</option>
                        <option value='Life Member'>Life Members</option>
                        <option value='Student'>Student Members</option>
                        <option value='Associate'>Associate Members</option>
                    </select>
                    <select className="NewSelects" onChange={(e) => setstatus(e.target.value)}>
                        <option value='all'>Select status</option>
                        <option value='Active'>Active</option>
                        <option value='Inactive'>Inactive</option>
                    </select>
                </div>
            </div>
            <div className="ctrl">
                <TextField name="title" label="Title *" onChange={(e) => { setTitle(e.target.value) }} variant="outlined" style={{ width: "528px" }} />
                {subject ? <p style={{ color: "red", fontSize: "15px", position: 'relative', bottom: '0px' }}>{subjectError}</p> : <p></p>}

            </div>
            <div className="ctrl">
                <TextareaAutosize name="Notice" label="type *" onChange={(e) => { setNotice(e.target.value) }} minRows={15} style={{ width: "528px", position: "relative", top: "10px" }} variant="outlined" />
                {
                    notice ? <p style={{ color: "red", fontSize: "15px", position: 'relative', bottom: '20px' }}>{noticeError}</p> : <p></p>
                }

            </div>
            <div className="ctrl">
                Attachments (PDF Documents)
                <input name="firstImg" type="file" onChange={uploadImg} accept="file" />
                <LinearProgress variant="determinate" value={Progress1} />
                <input name="secondImg" type="file" onChange={uploadImg} accept="file" />
                <LinearProgress variant="determinate" value={Progress2} />
                <input name="thirdImg" type="file" onChange={uploadImg} accept="file" />
                <LinearProgress variant="determinate" value={Progress3} />
                <input name="fourthImg" type="file" onChange={uploadImg} accept="file" />
                <LinearProgress variant="determinate" value={Progress4} />
                <input name="fifthImg" type="file" onChange={uploadImg} accept="file" />
                <LinearProgress variant="determinate" value={Progress5} />
            </div>

            <div >
                <Button variant="contained" color="Secondary" onClick={handleCancel} >Cancel</Button>
                <Button variant="contained" style={{ font: "15px", position: 'relative', left: "50px", margin: "20px" }} color="primary" onClick={handleData} >Save Notice</Button>
                {/* <Button variant="contained" style={{ position: 'relative', left: "100px" }} disabled={!sendMeMail} onClick={sendMail} color="primary" >Send Email</Button> */}
            </div>
            <Dialog open={IsOpen1} >
                <DialogTitle >{"Update Data?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to Send Mail?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSend} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNoApp} color="secondary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={IsOpen2} >
                <DialogTitle >{"Update Data?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure, you want to Save Notice?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSave} color="primary">
                        Yes
                    </Button>
                    <Button onClick={handleNosave} color="secondary">
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>







    )
}

export default NoticeForm
